export const DURATION = 180000;
